<div class="content-area sdps-p-left_medium sdps-p-right_medium sdps-p-bottom_medium">

  <div *ngIf="sharedService.errorMessage | async" [ngClass]="{'sdps-p-top_large' : businessUnit !== getSharedConstant.rbsBUText}">
    <ems-service-error *ngIf="sharedService.errorMessage | async"></ems-service-error>
  </div>
  <div *ngIf="(sharedService.showHistoricalView | async) && !(sharedService.errorMessage | async)"
    [ngClass]="{'sdps-p-top_large' : businessUnit !== getSharedConstant.rbsBUText}">
    <ems-service-error
      *ngIf="(sharedService.showHistoricalView | async) && !(sharedService.errorMessage | async)"></ems-service-error>
  </div>
  <div class="workbench-main-layout display-chart" [ngClass]="{'quick-actions-collapsed': isQuickActionsCollapsed, 'dbs-layout': businessUnit === getSharedConstant.dbsBUText}">
    <div class="quick-actions-panel" *ngIf="showPanel && (showPanel.hasAddlink || showPanel.hasEmtr) "
      [ngClass]="{'collapsed': isQuickActionsCollapsed, 'col-6': showPanel.hasEmtr && showPanel.hasAddlink, 'col': showPanel.hasEmtr && !showPanel.hasAddlink, 'sdps-hide': !showPanel.hasEmtr && !showPanel.hasAddlink}"> 
      <div class="sdps-m-top_small quick-actions-panel-content border-color" [hidden]="isQuickActionsCollapsed">
        <div class="container-title sdps-p-vertical_x-small quick-actions-header">
          <span class="sdps-p-left_x-small sdps-font-weight-bold"
            [innerHTML]="shellConstant.workBenchChart.quickActionsTxt"></span>
          <button type="button" class="btn-icon-only cursor quick-actions-toggle-inline"
            [attr.aria-expanded]="!isQuickActionsCollapsed"
            [attr.aria-label]="isQuickActionsCollapsed ? 'Expand Quick Actions section' : 'Collapse Quick Actions section'"
            aria-controls="quickActionsLinks" (click)="toggleQuickActionsSection()">
            <span class="quick-actions-toggle-icon sch-chevron-left" aria-hidden="true"></span>
          </button>
        </div>
        <div id="quickActionsLinks" class="sdps-p-vertical_x-small sdps-p-left_x-small sdps-p-right_x-small">
          <ng-container *ngIf="showPanel.hasAddlink">
          <span class="quick-actions-group-title" [innerHTML]="shellConstant.workBenchChart.addLink.addlinkTxt"></span>
          <ul class="quick-link-list quick-link-list--addLink">
            <li *ngFor="let link of addlinkQuickLinks">
              <button type="button" (click)="quickLinkNavigation(link.link, link.gutTrack)">
                <em *ngIf="link.icon" class="quick-link-icon" [ngClass]="link.icon" aria-hidden="true"></em>
                <span class="quick-link-name">{{link.name}}</span>
                <span class="sch-chevron-right link-right-icon" aria-hidden="true"></span>
              </button>
            </li>
          </ul>
          </ng-container>
          <div *ngIf="showPanel.hasEmtr && !sharedService.showHistoricalView.value">
            <span class="quick-actions-group-title" [innerHTML]="shellConstant.workBenchChart.rules.rulesTxt"></span>
            <ul class="quick-link-list quick-link-list--rules">
              <li *ngFor="let link of tradeRulesLinks">
                <button type="button" (click)="quickLinkNavigation(link.link, link.gutTrack)">
                  <em *ngIf="link.icon" class="quick-link-icon" [ngClass]="link.icon" aria-hidden="true"></em>
                  <span class="quick-link-name">{{link.name}}</span>
                  <span class="sch-chevron-right link-right-icon" aria-hidden="true"></span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button *ngIf="isQuickActionsCollapsed" type="button" class="quick-actions-toggle-vertical"
        [attr.aria-expanded]="!isQuickActionsCollapsed"
        [attr.aria-label]="isQuickActionsCollapsed ? 'Expand Quick Actions section' : 'Collapse Quick Actions section'"
        aria-controls="quickActionsLinks" (click)="toggleQuickActionsSection()">
        <span class="quick-actions-label" [innerHTML]="shellConstant.workBenchChart.quickActionsTxt"></span>
        <span class="quick-actions-toggle-icon sch-chevron-down" aria-hidden="true"></span>
      </button>
    </div>

    <!-- ADDLINK STATUS -->
    <div class="addlink-column" *ngIf="showPanel && showPanel.hasAddlink"
      [ngClass]="{'addlink-no-emtr': !showPanel?.hasEmtr}">
      <div class="sdps-is-relative sdps-m-top_small">
        <div class="full-width border-color" [ngClass]="{'section-error-state': addlinkError}">
          <app-workbench-panel-header
            [showRefresh]="false"
            [lastUpdatedTxt]="shellConstant.workBenchChart.panelLastUpdatedTxt"
            [lastUpdatedTime]="addlinkData.addlinkTimestamp"
            [headerTxt]="shellConstant.workBenchChart.addLink.addlinkStatusTxt"></app-workbench-panel-header>
          @if (addlinkLoading) {
          <div class="section-loading-state" role="status" aria-label="Loading addlink section">
            <span class="sch sch-spinner sch-spin-stepped section-loader-icon" aria-hidden="true"></span>
          </div>
          } @else if (!addlinkError) {
          <div class="sdps-p-vertical_x-small sdps-p-left_x-small sdps-p-right_x-small background-color-table addlink-status-grid" 
            [ngClass]="{'addlink-status-grid--two-col': businessUnit === getSharedConstant.rbsBUText || (!sharedService.isInternalApp() && !isLoaSectionVisible)}">
            <div class="sdps-row" *ngIf="businessUnit !== getSharedConstant.rbsBUText && !this.accessOnlyForRbs && (this.accessWithAuthorizedAgentDBS || this.accessWithAuthorizedAgentSPS)">
              <button type="button" class="col-6 request-status-hold sdps-p-vertical_medium sdps-p-horizontal_none btn-card"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.onHold)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.onHold + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.onHold"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small" [innerHTML]="addlinkData.onHoldCount"></span>
                    </div>
                  </div>
                </div>
              </button>
              <button type="button" class="col-6 sdps-p-horizontal_none request-status-validation sdps-p-vertical_medium sdps-m-left_xx-small btn-card"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.validationMismatch)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.validationMismatch + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.validationMismatch"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                        [innerHTML]="addlinkData.validationMismatchCount"></span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!-- DBS Action Needed is hidden from external users please don't ulter this section -->
            <div class="sdps-row sdps-p-top_x-small" *ngIf="businessUnit !== getSharedConstant.rbsBUText && !this.accessOnlyForRbs && (this.accessWithAuthorizedAgentDBS || this.accessWithAuthorizedAgentSPS)">
              <button type="button" class="col-6 sdps-p-horizontal_none request-status-dbs sdps-p-vertical_medium btn-card"
                [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid, '', '') || !sharedService.isInternalApp()}"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.DBSActionNeeded)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.DBSActionNeeded + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.DBSActionNeeded"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                        [innerHTML]="addlinkData.dbsActionNeededCount"></span>
                    </div>
                  </div>
                </div>
              </button>
              <button type="button" class="col-6 sdps-p-horizontal_none request-status-indexing sdps-p-vertical_medium sdps-m-left_xx-small btn-card"
                [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid, '', '') || !sharedService.isInternalApp()}"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.requireIndexing)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.requireIndexing + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.requireIndexing"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                        [innerHTML]="addlinkData.requireIndexing"></span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <div class="sdps-row sdps-p-top_x-small">
              <button type="button" class="col-6 sdps-p-horizontal_none request-status-cc-links sdps-p-vertical_medium btn-card"
                [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid, '', '') || !sharedService.isInternalApp()}"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.clientCentralLinks)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.clientCentralLinks + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.clientCentralLinks"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                        [innerHTML]="addlinkData.clientCentralLinks"></span>
                    </div>
                  </div>
                </div>
              </button>
              <button type="button" class="col-6 sdps-p-horizontal_none request-status-cc-delinks sdps-p-vertical_medium sdps-m-left_xx-small btn-card"
                [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid, '', '') || !sharedService.isInternalApp()}"
                (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.clientCentralDelinks)"
                [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.clientCentralDelinks + ' requests'">
                <div class="count-block sdps-text-center">
                  <div>
                    <div>
                      <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                        [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.clientCentralDelinks"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                        [innerHTML]="addlinkData.clientCentralDelinks"></span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <ng-container *ngIf="isLoaSectionVisible">
              <div class="sdps-row sdps-p-top_x-small">
                <button type="button" class="col-6 sdps-p-horizontal_none request-status-loa-pending sdps-p-vertical_medium btn-card"
                  (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.loaPending)"
                  [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.loaPending + ' requests'">
                  <div class="count-block sdps-text-center">
                    <div>
                      <div>
                        <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                          [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.loaPending"></span>
                      </div>
                    </div>
                    <div>
                      <div>
                        <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                          [innerHTML]="addlinkData.loaPendingCount"></span>
                      </div>
                    </div>
                  </div>
                </button>
                <button type="button" class="col-6 sdps-p-horizontal_none request-status-loa-error sdps-p-vertical_medium sdps-m-left_xx-small btn-card"
                  (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.loaError)"
                  [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.loaError + ' requests'">
                  <div class="count-block sdps-text-center">
                    <div>
                      <div>
                        <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                          [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.loaError"></span>
                      </div>
                    </div>
                    <div>
                      <div>
                        <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                          [innerHTML]="addlinkData.loaErrorCount"></span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
              <div class="sdps-row sdps-p-top_x-small">
                <button type="button" class="col-6 sdps-p-horizontal_none request-status-loa-review sdps-p-vertical_medium btn-card"
                  (click)="redirectToRequestList(shellConstant.workBenchChart.addLink.requestStatus.loaInReview)"
                  [attr.aria-label]="'View ' + shellConstant.workBenchChart.addLink.requestStatus.loaInReview + ' requests'">
                  <div class="count-block sdps-text-center">
                    <div>
                      <div>
                        <span class="sdps-display-inline-block sdps-font-weight-bold display-status-text-all"
                          [innerHTML]="shellConstant.workBenchChart.addLink.requestStatus.loaInReview"></span>
                      </div>
                    </div>
                    <div>
                      <div>
                        <span class="sdps-font-weight-bold sdps-display-inline-block display-count sdps-p-top_xx-small"
                          [innerHTML]="addlinkData.loaInReviewCount"></span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="businessUnit !== getSharedConstant.rbsBUText && orgId && showPanel.hasAddlink">
            <div
              class="sdps-p-top_x-small sdps-p-left_x-small sdps-p-right_x-small sdps-p-bottom_x-small background-color-table">
              <div class="sdps-row sdps-p-vertical_medium sdps-p-horizontal_large master-account">
                <div class="col-1">
                  <span class="sdps-p-right_medium sdps-display-inline-block master-acc-count sdps-font-weight-bold"
                    [innerHTML]="masterAccCount"></span>
                </div>
                <div class="col-9">
                  <span class="sdps-display-inline-block sdps-font-weight-bold sdps-checkbox__input"
                    [innerHTML]="shellConstant.workBenchChart.addLink.masterAcc.masterAccTxt"></span>
                </div>
              </div>
            </div>
          </ng-container>
          } @else {
            <div class="section-error-state__body section-error-state__body--visual" role="alert">
              <div class="section-error-icon-wrapper">
                <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                </svg>
              </div>
              <h4 class="section-error-title">{{getSharedConstant.tradeChart.errorState.heading}}</h4>
              <p class="section-error-text">{{ getSharedConstant.tradeChart.errorState.sectionUnavailableMessage }}</p>
            </div>
          }
        </div>
      </div>
    </div> 
        <!-- Trade Attempts Chart -->
        <div *ngIf="showPanel && showPanel.hasEmtr" class="sdps-m-top_small trade-attempts-column" [ngClass]="{'trade-attempts-no-addlink': !showPanel?.hasAddlink}">
          <ems-trade-chart [data]="tradeAttemptData" [loading]="tradeAttemptLoading" [error]="tradeAttemptError" [tabs]="tradeAttemptTabLabels"
            [allSelected]="!orgId" [clientKey]="activeCacheKey" (downloadReport)="onTradeAttemptDownloadReport($event)">
          </ems-trade-chart>
        </div>

         <!-- Authorized Agent List Section -->
        <div class="authorized-agents-row border-color" *ngIf="orgId && showAAPanel && showPanel && showPanel.hasAddlink"
          [ngClass]="{'authorized-agents-full-width': !showPanel?.hasEmtr}">
      <app-workbench-panel-header
        [showRefresh]="false"
        [lastUpdatedTxt]="shellConstant.workBenchChart.panelLastUpdatedTxt"
        [lastUpdatedTime]="(authorizedAgentData.agentTimestamp && authorizedAgentData.agentTimestamp !== 'undefined') ? authorizedAgentData.agentTimestamp : ''"
        [headerTxt]="shellConstant.workBenchChart.addLink.authorizedAgents"></app-workbench-panel-header>
      @if (!authorizedAgentError) {
      <form [formGroup]="authorizedAgentForm" class="reportListMenu">
        <div class="sdps-row sdps-is-relative">
          <app-workbench-loader *ngIf="loader && loadSection === 'authorizedAgents'"></app-workbench-loader>
          <p-table #authAgentTable id="workbench_authAgentTable" [columns]="authAgentTableColumn" [value]="authAgentList"
            [paginator]="authAgentList && authAgentList.length>15" [rows]="noOfRecords"
            [totalRecords]="authAgentList && authAgentList.length" [(first)]="pageNumResetToFirst"
            class="common-data-table auth-agent-table-layout-fixed" alwaysShowPaginator="true" sortField="authAgentLastNm">
            <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
              <span class="pi" [ngClass]="{
                              'pi-sort': sortOrder === 0,
                              'pi-caret-down': sortOrder === 1,
                              'pi-caret-up': sortOrder === -1,
                            }"></span>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <!-- Header -->
              <tr class="filter-header-input">
                <th class="table-checkbox-selection filter-icon">
                  <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter"
                    [attr.aria-expanded]="toggle">
                    <em class="pi pi-filter" aria-hidden="true"></em>
                  </button>
                </th>
                <ng-container *ngFor="let col of columns">
                  <th *ngIf="col.field !== 'action'" [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.field === 'action'" (click)="isSortingChanged = true"
                    [ngClass]="authAgentList && authAgentList.length > 1 || isFilterApplied ? 'pointer-events-auto' : 'pointer-events-none'">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"
                      *ngIf="authAgentList && authAgentList.length > 1 || isFilterApplied"></p-sortIcon>
                  </th>
                </ng-container>
              </tr>
      
              <!-- Filter input fields -->
              <tr *ngIf="toggle" class="filtered-row-input">
                <th></th>
                <th *ngFor="let col of columns" class="sdps-p-left_small">
                  <input pInputText [attr.aria-label]="col.header + ' filter'" emsStartSpaceValidator
                    *ngIf="col.field !== 'action'" [formControlName]="col.field" class="w-100-per" type="text" name="filter"
                    (keydown.enter)="!authorizedAgentForm.invalid ? applyFilter() : ''"
                    onkeydown="return (event.keyCode !== 13);"
                    [ngClass]="{'invalidField': col.field === 'authAgentFirstNm' ? authorizedAgentForm.get('authAgentFirstNm').invalid : authorizedAgentForm.get('authAgentLastNm').invalid }">
                  <div *ngIf="col.field === 'action'" class="sdps-p-right_none">
                    <button class="buttons button-filter"
                      [innerHTML]="shellConstant.uploadListPage.uploadsListFilter.clearButton"
                      [disabled]="!authorizedAgentForm.dirty && !isSortingChanged"
                      (click)="isSortingChanged || isFilterApplied ? authAgentTable.reset() : '';resetFilterAndSortApplied()"></button>
                    <button class="buttons button-save button-filter" [disabled]="authorizedAgentForm.invalid"
                      (click)="applyFilter()"
                      [innerHTML]="shellConstant.uploadListPage.uploadsListFilter.applyButton"></button>
                  </div>
                </th>
              </tr>
            </ng-template>
            <!-- Empty Message section -->
            <ng-template pTemplate="emptymessage" let-columns>
              <tr *ngIf="authAgentList && authAgentList.length === 0">
                <td [attr.colspan]="columns.length + 1" class="sdps-text-center"
                  [innerHTML]="shellConstant.manageUserPage.noRecords"></td>
              </tr>
            </ng-template>
            <!-- Table body section -->
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td></td>
                <td *ngFor="let col of columns">
                  {{rowData[col.field]}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>
      } @else {
      <div class="section-error-state__body section-error-state__body--visual" role="alert">
        <div class="section-error-icon-wrapper">
          <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
          </svg>
        </div>
        <h4 class="section-error-title">{{getSharedConstant.tradeChart.errorState.heading}}</h4>
        <p class="section-error-text">{{ getSharedConstant.tradeChart.errorState.sectionUnavailableMessage }}</p>
      </div>
      }
    </div>

    <!--TRADE RULES TIMELINE -->
    <div class="trade-rules-column" [ngClass]="{'trade-rules-full-width': businessUnit !== getSharedConstant.dbsBUText || !showPanel?.hasAddlink}" *ngIf="showPanel && showPanel.hasEmtr">
      <div class="rules-section border-color sdps-is-relative" [ngClass]="{'section-error-state': donutError}">
        <div class="container-title sdps-p-horizontal_none">
          <span [innerHTML]="shellConstant.workBenchChart.rules.rulesTimelineTxt"
            class="sdps-p-left_x-small sdps-font-weight-bold"></span>
        </div>
        @if (donutLoading) {
        <div class="section-loading-state" role="status" aria-label="Loading trade rules timeline section">
          <span class="sch sch-spinner sch-spin-stepped section-loader-icon" aria-hidden="true"></span>
        </div>
        } @else if (donutError) {
        <div class="section-error-state__body section-error-state__body--visual" role="alert">
          <div class="section-error-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
            </svg>
          </div>
          <h4 class="section-error-title">{{getSharedConstant.tradeChart.errorState.heading}}</h4>
          <p class="section-error-text">{{ getSharedConstant.tradeChart.errorState.sectionUnavailableMessage }}</p>
        </div>
        } @else {
        <div class="sdps-row chart-dropdown sdps-p-vertical_x-small">
          <div class="col-6 border-right" id="restrictionStartDateSection">
            <!-- Start Date Section -->
            <span class="date-title"><span class="sdps-p-around_x-small sdps-m-right_x-small resRuleTypeTxt"
                [innerHTML]="shellConstant.workBenchChart.rules.restrictionTxt"></span> <span
                [innerHtml]="shellConstant.workBenchChart.rules.startDateTxt"></span></span>
            <div class="chart-holder">
              <span *ngIf="!validateResponse(restrictStartDtValues)">{{shellConstant.workBenchChart.rules.noOfRulesStartDateTxt}}&nbsp;
                <p-select [options]="startDateArr" [(ngModel)]="selectedStartDate"
                  aria-label="Restriction start date range" optionLabel="label"
                  (onChange)="getDropdownVal(selectedStartDate, 'startDate', 'restriction')"
                  class="sdps-display-inline-block"></p-select>
                {{shellConstant.workBenchChart.rules.fromTodayTxt}}
              </span>
              <sdps-notification type="information" class="sdps-m-top_none" *ngIf="validateResponse(restrictStartDtValues)">
                <span class="sdps-notification__text" [innerHtml]="shellConstant.workBenchChart.rules.noDataTxt"></span>
              </sdps-notification>
              <div class="sdps-flex align-center" *ngIf="!validateResponse(restrictStartDtValues)">
                <ems-donut-chart #child [labelVal]="restrictStartDtLabel" [chartTitle]="2"
                  [arrayVal]="restrictStartDtValues"
                  [restrictBackgroundColorCode]="shellConstant.workBenchChart.restrictionBgColorStartDate"></ems-donut-chart>
              </div>
            </div>
          </div>
          <!-- End Date Section -->
          <div class="col-6" id="restrictionEndDateSection">
            <span class="date-title"><span class="sdps-p-around_x-small sdps-m-right_x-small resRuleTypeTxt"
                [innerHTML]="shellConstant.workBenchChart.rules.restrictionTxt"></span> <span
                [innerHtml]="shellConstant.workBenchChart.rules.endDateTxt"></span></span>
            <div class="chart-holder">
              <span *ngIf="!validateResponse(restrictEndDtValues)">{{shellConstant.workBenchChart.rules.noOfRulesEndDateTxt}}&nbsp;
                <p-select [options]="endDateArr" [(ngModel)]="selectedEndDate" aria-label="Restriction end date range"
                  (onChange)="getDropdownVal(selectedEndDate, 'endDate', 'restriction')" optionLabel="label"
                  class="sdps-display-inline-block"></p-select>
                {{shellConstant.workBenchChart.rules.fromTodayTxt}}
              </span>
              <sdps-notification type="information" class="sdps-m-top_none" *ngIf="validateResponse(restrictEndDtValues)">
                <span class="sdps-notification__text" [innerHtml]="shellConstant.workBenchChart.rules.noDataTxt"></span>
              </sdps-notification>
              <div class="sdps-flex align-center" *ngIf="!validateResponse(restrictEndDtValues)">
                <ems-donut-chart #child [labelVal]="restrictEndDtLabel" [chartTitle]="2"
                  [arrayVal]="restrictEndDtValues"
                  [restrictBackgroundColorCode]="shellConstant.workBenchChart.restrictionBgColorEndDate"></ems-donut-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="sdps-row chart-dropdown sdps-p-vertical_x-small workbench-border-top">
          <!-- Start Date Section -->
          <div class="col-6 border-right" id="overrideStartDateSection">
            <span class="date-title"><span class="sdps-p-around_x-small sdps-m-right_x-small ovrdRuleTypeTxt" [innerHTML]="shellConstant.workBenchChart.rules.overrideTxt"></span> <span
                [innerHtml]="shellConstant.workBenchChart.rules.startDateTxt"></span></span>
            <div class="chart-holder">
              <span *ngIf="!validateResponse(overrideStartDtValues)">{{shellConstant.workBenchChart.rules.noOfRulesStartDateTxt}}&nbsp;
                <p-select [options]="startDateArr" [(ngModel)]="selectedOverrideStartDate"
                  aria-label="Override start date range"
                  (onChange)="getDropdownVal(selectedOverrideStartDate, 'startDate', 'override')" 
                  optionLabel="label"
                  class="sdps-display-inline-block"></p-select>
                {{shellConstant.workBenchChart.rules.fromTodayTxt}}</span>
              <sdps-notification type="information" class="sdps-m-top_none" *ngIf="validateResponse(overrideStartDtValues)">
                <span class="sdps-notification__text" [innerHtml]="shellConstant.workBenchChart.rules.noDataTxt"></span>
              </sdps-notification>
              <div class="sdps-flex align-center" *ngIf="!validateResponse(overrideStartDtValues)">
                <ems-donut-chart #child [labelVal]="overrideStartDtLabel" [chartTitle]="2"
                  [arrayVal]="overrideStartDtValues"
                  [restrictBackgroundColorCode]="shellConstant.workBenchChart.overrideBgColorStartDate"></ems-donut-chart>
              </div>
            </div>
          </div>
          <!-- End Date Section -->
          <div class="col-6" id="overrideEndDateSection">
            <div>
              <span class="date-title"><span class="sdps-p-around_x-small sdps-m-right_x-small ovrdRuleTypeTxt"
                  [innerHTML]="shellConstant.workBenchChart.rules.overrideTxt"></span> <span
                  [innerHtml]="shellConstant.workBenchChart.rules.endDateTxt"></span></span>
              <span *ngIf="!validateResponse(overrideEndDtValues)">{{shellConstant.workBenchChart.rules.noOfRulesEndDateTxt}}&nbsp;
                <p-select [options]="overrideEndDateArr" [(ngModel)]="selectedOverrideEndDate"
                  aria-label="Override end date range"
                  (onChange)="getDropdownVal(selectedOverrideEndDate, 'endDate', 'override')" optionLabel="label"
                  class="sdps-display-inline-block"></p-select>
                {{shellConstant.workBenchChart.rules.fromTodayTxt}}</span>
              <sdps-notification type="information" class="sdps-m-top_none" *ngIf="validateResponse(overrideEndDtValues)">
                <span class="sdps-notification__text" [innerHtml]="shellConstant.workBenchChart.rules.noDataTxt"></span>
              </sdps-notification>
              <div class="sdps-flex align-center" *ngIf="!validateResponse(overrideEndDtValues)">
                <ems-donut-chart #child [labelVal]="overrideEndDtLabel" [chartTitle]="2"
                  [arrayVal]="overrideEndDtValues"
                  [restrictBackgroundColorCode]="shellConstant.workBenchChart.overrideBgColorEndDate"></ems-donut-chart>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<ems-confirm-message #confirmationMessage></ems-confirm-message>
